<template>
    <div>
        <el-drawer :modal="false" 
            title="Request Prescreening Analysis"
            :visible.sync="drawerBuyFintscoreReport"
            class="drawer-buy-fintscore"
            size="45%"
        >
            <b-container>
                <b-row>
										<b-col cols="12">
											<div class="m-2">
												<span class="text-danger font-weight-400" v-if="!auth_user.subscription.scrb_is_my_own">You're currently entitled to use  {{ auth_user.subscription.privileges.scpk_name }}  report balance, please be mindful on purchasing the report.</span>
											</div>
										</b-col>
                    <b-col cols="12">
                        <div class="mb-3">
                            <div class="mb-2 mx-2 py-3 px-4 rounded d-flex align-items-center justify-content-between" style="background-color: #252938;">
                                <h3 class="mb-0 text-white d-flex align-items-center">
                                    <span class="mr-2">Available Credit Points</span>
                                    <span class="badge bg-fintos text-dark">{{ _gAuth.activeUser('subscription.scrb_credit_points',0) }}</span>
                                </h3>
                                <!-- <h3 class="mb-0 text-white d-flex align-items-center">
                                    <span class="mr-2">Available Request</span>
                                    <span class="badge bg-fintos text-dark">{{ auth_user.subscription.scrb_credit_report }}</span>
                                </h3>
                                <h3 class="mb-0 text-white d-flex align-items-center">
                                    <span class="mr-2">Free Request</span>
                                    <span class="badge bg-success text-dark">{{ auth_user.subscription.scrb_free_report }}</span>
                                </h3> -->
                            </div>
                            <p
                                v-if="auth_user.subscription.scrb_is_my_own || checkRoleType(['admin'])"
                                class="text-right px-2">Need more reports? <a href="javascript:void(0)" @click="showReloadModal">Reload Here.</a> </p>
                        </div>
                        <div class="consent-form border rounded mx-2 mb-3 px-2 py-3" v-loading="is_loading_esign">
														<h3 class="d-flex align-items-center">
                                <span class="badge bg-fintos my-auto px-2 mr-2">Step 1</span> 
                                <span>Chose CCRIS Report Platform</span>
                            </h3>
														<!-- <div class="row mb-4">
															<div class="col-12">
																<div class="d-flex align-items-center"> -->
																	<!-- <el-button v-if="!_gAuth.isAppSas() || _gHlp.checkAccess(['allow_pull_ctos'])" :type="(form.platform == 'CTOS') ? 'primary' : 'plain'" class="px-5" @click="selectPlatformType('CTOS')">CTOS</el-button> -->
                                  <!-- <el-button v-if="!_gAuth.isAppSas()" :type="(form.platform == 'CBM') ? 'primary' : 'plain'" class="px-5" @click="selectPlatformType('CBM')">CBM</el-button> -->
                                  <!-- <el-button :type="(form.platform == 'CBM') ? 'primary' : 'plain'" class="px-5" @click="selectPlatformType('CBM')">CBM</el-button>
																</div>
															</div>
														</div> -->
                              <div class="row mb-4">
                                <div class="col-12">
                                  <div class="d-flex mb-3">
                                    <el-button
                                      :class="form.platform === 'CBM' ? 'bg-primary text-white' : 'bg-light text-primary'"
                                      style="min-width:180px; margin-right: 12px;"
                                      @click="form.platform = 'CBM'"
                                    >
                                      {{ _gAuth.isAppSas() ? 'CBM' : 'Premium Report' }}
                                    </el-button>

                                    <el-button
                                      :style="form.platform === 'CTOS'
                                        ? 'min-width:220px;background-color:#006400;color:white;'
                                        : 'min-width:220px;background-color:#f8f9fa;color:#006400;'"
                                      @click="form.platform = 'CTOS'"
                                    >
                                      {{ _gAuth.isAppSas() ? 'CTOS' : 'Comprehensive Report' }}
                                    </el-button>
                                  </div>

                              
                                  <!-- CBM Checkboxes -->
                                  <div v-if="form.platform === 'CBM'" class="mt-3">
                                  <b-form-checkbox 
                                      size="lg" 
                                      class="my-2" 
                                      v-model="form.trade_reference" 
                                    >
                                      <p class="font-weight-normal pt-1 mb-0">Trade Reference And Legal Status</p>
                                    </b-form-checkbox>

                                    <!-- <b-form-checkbox size="lg" class="my-2" v-model="form.ccris" :disabled="true">
                                      <p class="font-weight-normal pt-1 mb-0">CCRIS Details</p>
                                    </b-form-checkbox> -->
                                  </div>
                              
                                  <!-- CTOS Checkboxes -->
                                  <div v-if="form.platform === 'CTOS'" class="mt-3 text-muted">
                                    <h4 class="mb-0">Optional</h4>
                                    <b-form-checkbox size="lg" class="my-2" v-model="form.liabilities">
                                      <p class="font-weight-normal pt-1 mb-0">LG - Liabilities as Guarantor</p>
                                    </b-form-checkbox>
                                    <b-form-checkbox size="lg" class="my-2" v-model="form.ccris">
                                      <p class="font-weight-normal pt-1 mb-0">CCRIS Supplementary</p>
                                    </b-form-checkbox>
                                    <b-form-checkbox size="lg" class="my-2" v-model="form.angkasa">
                                      <p class="font-weight-normal pt-1 mb-0">Angkasa(SPGA)</p>
                                    </b-form-checkbox>
                                  </div>
                                </div>
                              </div>
                            <h3 class="d-flex align-items-center">
                                <span class="badge bg-fintos my-auto px-2 mr-2">Step 2</span> 
                                <span>Upload consent form</span>
                            </h3>
														<div class="row mb-4">
															<div class="col-12">
                                <div class="d-flex justify-content-between align-items-center">
                                    <h3 class="mb-0 d-flex align-items-center"><span class="badge bg-secondary px-2 mr-1">Option 1</span> Esign</h3>
                                    <el-button type="text" @click="getNewConsentHandler(current_customer)" :loading="is_generate_new_esign">Generate New Esign</el-button>
                                </div>
                                <div v-if="latest_consent 
                                  && latest_consent.esign_status == 2 
                                  && effectivePlatform === latest_consent.esign_platform">
												    		<el-button type="text" 
																		@click="$refs.preview_modal.preview(latest_consent.esign_attachment[1].attachment_unsigned_url)"
																		>
																				<b-icon icon="pen-fill" font-scale="1.2"></b-icon>
																				Preview Latest Esign
																		</el-button>
																		<b-form-checkbox
																			v-model="is_use_esign"
																			class="my-auto"
																			>
																			Use this Esign to purchase.
																		</b-form-checkbox>
																</div>
																<div v-if="latest_consent && ([0,1].includes(latest_consent.esign_status) || is_new_esign)">
																		<b-form-group  
																				label="Share the link to e-sign or sign now. refresh this page after complete sign process"
																				label-cols="12"
																				content-cols="12">
																						<b-input-group class="mb-2">
																								<b-form-input
																								v-model="latest_consent.esign_url"
																								type="text"
																								readonly
																								></b-form-input>
																								<!-- <b-input-group-append>
																										<b-button variant="primary" class="px-5" @click="_gHlp.copyToClipboard(latest_consent.esign_url)">
																												<b-icon icon="files" aria-hidden="true"></b-icon>
																												Copy
																										</b-button>
																										<b-button variant="danger" class="px-5" @click="_gHlp.openNewTab(latest_consent.esign_url + '?no_otp=1')">
                                                        <b-icon icon="pen" aria-hidden="true"></b-icon>
                                                        Sign Now
                                                    </b-button>
																								</b-input-group-append> -->
                                               <b-input-group-append>
																										<b-button variant="primary" class="px-5" @click="_gHlp.copyToClipboard(latest_consent.esign_url + '?platform=' + (form.platform === 'CBM' && form.trade_reference ? 'CBM_TR' : form.platform))">
																												<b-icon icon="files" aria-hidden="true"></b-icon>
																												Copy
																										</b-button>
																										<b-button variant="danger" class="px-5" @click="_gHlp.openNewTab(latest_consent.esign_url + '?platform=' + (form.platform === 'CBM' && form.trade_reference ? 'CBM_TR' : form.platform) + '&no_otp=1')">
                                                        <b-icon icon="pen" aria-hidden="true"></b-icon>
                                                        Sign Now
                                                    </b-button>
																								</b-input-group-append>
																						</b-input-group>
																						<a href="javascript:void(0)" @click="getEsignConsentHandler">
																								<b-icon icon="arrow-clockwise"></b-icon>
																								Refresh
																						</a>
																		</b-form-group>
																</div>
																<p v-if="!latest_consent" class="text-muted">No Esign found / Link has expired. Please generate a new one.</p>
															</div>
															<div class="col-12">
																	<b-form-group
																	class=" mt-0"
																	label-cols="12">
																			<h3 class="mb-0 d-flex align-items-center"><span class="badge bg-secondary px-2 mr-1">Option 2</span> Manual</h3>
																			<el-button type="text" @click="previewConsentForm">
																					<b-icon icon="cloud-download-fill" font-scale="1.2"></b-icon>
																					<!-- {{ (form.platform == 'CBM') ? 'Download CBM Consent Form':'Download CTOS Consent Form' }} -->
                                            {{ 'Download Consent Form' }}
																			</el-button>
                                                                            <ConsentFormPerviewModal 
                                                                                :show_preview.sync="modals.show_preview"
                                                                                :company_entity_name="modals.company_entity_name"
                                                                                :platform="effectivePlatform"/>
																			<vue-dropzone id="consentFormDropzone" 
																					ref="consentFormDropzone"
																					:options="dropzoneOptions" 
																					:useCustomSlot=true
																					v-on:vdropzone-error="dropzoneErrorConsentForm"
																					v-on:vdropzone-file-added="dropzoneAddedConsentForm"
																					v-on:vdropzone-removed-file="dropzoneRemovedConsentForm"
																			>
																					<b-icon icon="cloud-arrow-up-fill" font-scale="3"></b-icon>
																					<p class="mb-0">Drop files here</p>
																			</vue-dropzone>
																			<small class="text-danger">Manual consent form will override Esign.</small>
																	</b-form-group>
															</div>
														</div>
                            <div>
                                <h3 class="d-flex align-items-center mb-3">
                                    <span class="badge bg-fintos my-auto px-2 mr-2">Step 3</span> 
                                    <span>Upload front and back NRIC</span>
                                </h3>
                                <b-row>
                                    <b-col cols="12" md="6">
                                        <vue-dropzone id="frontNRICDropzone" 
                                            ref="frontNRICDropzone"
                                            :options="dropzoneOptions"
                                            :useCustomSlot=true
                                            v-on:vdropzone-error="dropzoneErrorFrontNRIC"
                                            v-on:vdropzone-file-added="dropzoneAddedFrontNRIC"
                                            v-on:vdropzone-removed-file="dropzoneRemovedFrontNRIC"
                                            v-if="_gHlp.isEmpty(prev_b46_front_nric)"
                                        >
                                            <b-icon icon="cloud-arrow-up-fill" font-scale="3"></b-icon>
                                            <p class="mb-0">Front NRIC</p>
																				</vue-dropzone>
																				<div v-else>
																					<img class="img-fluid" :src="prev_b46_front_nric" alt="">
																					<a class="text-danger d-block" href="javascript:void(0)" @click="reupload('ic_front')"><i class="fa fa-times"></i> Reupload </a>
																				</div>
                                    </b-col>
                                    <b-col cols="12" md="6">
                                        <vue-dropzone id="backNRICDropzone" 
                                            ref="backNRICDropzone"
                                            :options="dropzoneOptions"
                                            :useCustomSlot=true
                                            v-model="form.back_nric"
                                            v-on:vdropzone-error="dropzoneErrorBackNRIC"
                                            v-on:vdropzone-file-added="dropzoneAddedBackNRIC"
                                            v-on:vdropzone-removed-file="dropzoneRemovedBackNRIC"
                                            v-if="_gHlp.isEmpty(prev_b46_back_nric)"
                                        >
                                            <b-icon icon="cloud-arrow-up-fill" font-scale="3"></b-icon>
                                            <p class="mb-0">Back NRIC</p>
																				</vue-dropzone>
																				<div v-else>
																					<img class="img-fluid" :src="prev_b46_back_nric" alt="">
																					<a class="text-danger d-block" href="javascript:void(0)" @click="reupload('ic_back')"><i class="fa fa-times"></i> Reupload </a>
																				</div>

                                    </b-col>
                                </b-row>
                                <!-- <small class="text-danger mt-2">Only JPEG/PNG file is allowed for NRIC upload.</small> -->
                            </div>
                        </div>
                        <!-- <div>
                            <h4 class="mb-0">FREE</h4>
                            <b-form-checkbox size="lg" class="my-2" v-model="form.fintscore" disabled>
                                <p class="font-weight-normal pt-1">FINTSCORE Report with Mortgage Eligibility</p>
                            </b-form-checkbox>
                        </div>
                        <div>
                            <h4 class="mb-0">Add On</h4>
                            <small class="text-danger">Adding this will redirect you to payment gateway instead of deducting from balance/Free Request.</small>
                            <b-form-checkbox size="lg" class="my-2" v-model="form.liabilities">
                                <p class="font-weight-normal pt-1">LG - Liabilities as Guarantor 
                                    <b class="mr-1" v-if="discount > 0"><s>RM{{ ctos_addons.ctos_lg_guarantor_price | moneyFormatter }}</s></b>    
                                    <b>RM{{ ctos_addons.disounct_ctos_lg_guarantor_price | moneyFormatter }}</b>
                                </p>
                            </b-form-checkbox>
                            <b-form-checkbox size="lg" class="my-2" v-model="form.ccris">
                                <p class="font-weight-normal pt-1">CCRIS Suplementary 
                                    <b class="mr-1" v-if="discount > 0"><s>RM{{ ctos_addons.ctos_ccris_price | moneyFormatter }}</s></b>    
                                    <b>RM{{ ctos_addons.disounct_ctos_ccris_price | moneyFormatter }}</b>
                                </p>
                            </b-form-checkbox>
                            <b-form-checkbox size="lg" class="my-2" v-model="form.angkasa">
                                <p class="font-weight-normal pt-1">Angkasa(SPGA) 
                                    <b class="mr-1" v-if="discount > 0"><s>RM{{ ctos_addons.ctos_angkasa | moneyFormatter }}</s></b>    
                                    <b>RM{{ ctos_addons.disounct_ctos_angkasa | moneyFormatter}}</b>
                                </p>
                            </b-form-checkbox>
                            <b-form-checkbox size="lg" class="my-2" v-model="form.trade_reference" v-if="form.platform == 'CBM'" disabled>
                                <p class="font-weight-normal pt-1">CTOS Trade Reference With Legal Summons 
                                    <b class="mr-1" v-if="discount > 0"><s>RM{{ ctos_addons.trade_reference | moneyFormatter }}</s></b>    
                                    <b>RM{{ ctos_addons.disounct_trade_reference | moneyFormatter}}</b>
                                </p>
                            </b-form-checkbox>
                        </div> -->
                    </b-col>
                    <b-col cols="12" class="border-top my-4 py-3 mx-3 text-center">
                        <div class="p-3 border border-danger rounded-lg mb-4" v-if="current_customer">
                            <p>Name: <span class="font-weight-bold">{{ current_customer.name }}</span></p>
                            <p>NRIC: <span class="font-weight-bold">{{ current_customer.nric }}</span></p>
                            <p>Date of Birth: <span class="font-weight-bold">{{ current_customer.dob }}</span></p>
                            <small class="text-danger">Please make sure the above details are correct.</small>
                        </div>
                        <p class="font-weight-normal">You only able to purchase once the consent form is sign by the customer</p>
                        
												<small class="text-warning" v-if="!isCreditEnough">Your balance point is not enough, please top up first or continue use direct payment.</small>
												<div class="d-flex justify-content-center mt-3">
                            <div>
																<!-- <el-button :class="(isCreditEnough) ? 'bg-primary text-white' : 'bg-fintos text-white'"
                                    @click="purchaseReport((isCreditEnough ? 0 : 1))" 
                                    :loading="is_loading_purchase"
                                ><b-icon icon="cart-fill"></b-icon> Prescreening Analysis
                                        <span v-if="!_gAuth.isAppVps()" > - only </span>
                                        <span v-if="discount > 0 && !_gAuth.isAppVps()" class="mr-1"> <s>{{ ctosPurchaseNoDiscountPrice | moneyFormatter }} Points</s> </span>
                                        <span v-if="!_gAuth.isAppVps()">{{ ctosPurchasePrice | moneyFormatter }} Points</span>
                                </el-button> -->
                                <el-button :class="(isCreditEnough) ? 'bg-primary text-white' : 'bg-fintos text-white'"
                                    @click="purchaseReport((isCreditEnough ? 0 : 1))" 
                                    :loading="is_loading_purchase"
                                ><b-icon icon="cart-fill"></b-icon> Prescreening Analysis
                                </el-button>
                                <small class="text-green d-block mt-2" v-if="discount > 0">
                                        {{ discount }}% discount applied!</small>
                            </div>
                        </div>
                        <!-- for indicator on production -->
                        <div class="text-white">
                            <small v-if="CTOS_TEST_MODE === 'true'">test</small>
                            <small v-else>real</small>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </el-drawer>
        <PreviewModal ref="preview_modal"></PreviewModal>
        <SignConsentModal :sign_form.sync="modals.sign_form"></SignConsentModal>
        <ReloadFintscoreCreditModal ref="reloadFintscoreCreditModalRef"/>
    </div>
</template>
<style>
#consentFormDropzone.dropzone .dz-preview .dz-progress {
  display: none !important
}
#frontNRICDropzone.dropzone .dz-preview .dz-progress {
  display: none !important
}
#backNRICDropzone.dropzone .dz-preview .dz-progress {
  display: none !important
}
.dz-preview .dz-error-message {
    top: 0px!important;
}
</style>
<script>
    import { Drawer, Button } from 'element-ui'
    import vue2Dropzone, { methods } from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
    import {axios, services, getHeader, helperFunctionMixin } from '@/assets/js/httpImports.js'
    import { mapState, mapActions } from 'pinia'
    import { useCustomerStore } from '@/stores/customerStore'
    import { useFintscoreStore } from '@/stores/fintscoreStore'
    import PreviewModal  from '@/components/Modal/PreviewModal'
    import SignConsentModal from '@/views/CustomerProfile/CustomerModals/SignConsentModal'
    import {CTOS_TEST_MODE} from '@/assets/js/config.js'
    import { useAuthStore } from '@/stores/authStore'
    import ReloadFintscoreCreditModal from './ReloadFintscoreCreditModal.vue'
    import ConsentFormPerviewModal from './ConsentFormPerviewModal.vue'

    export default {
        components: {
            vueDropzone: vue2Dropzone,
            [Drawer.name]: Drawer,
            [Button.name]: Button,
            PreviewModal,
            SignConsentModal,
            ReloadFintscoreCreditModal,
            ConsentFormPerviewModal
        },
        mixins: [notifyFunctionMixin, helperFunctionMixin],
        data() {
            return {
                drawerBuyFintscoreReport: false,
                dropzoneOptions: {	
                    url: '#',
                    addRemoveLinks: true,
                    maxFiles: 1,
                    autoProcessQueue: false,
                    acceptedFiles: "application/pdf,image/jpeg,image/png",
                },
                dropzoneOptionsImage: {	
                    url: '#',
                    addRemoveLinks: true,
                    maxFiles: 1,
                    autoProcessQueue: false,
                    acceptedFiles: "image/jpeg,image/png",
                },
                form: {
                    government_servant: false,
                    fintscore: true,
                    liabilities: false,
                    ccris: false,
                    angkasa: false,
										trade_reference:false,
                    consent_form: null,
                    base64_consent_form: null,
                    back_nric: null,
                    front_nric: null,
										platform: 'CBM'
                },
                modals: {
                    sign_form: false,
                    show_preview: false,
                    company_entity_name: ""
                },
                is_loading_purchase: false,
                initial_form_values: {},
                CTOS_TEST_MODE:CTOS_TEST_MODE,
                is_first_load:true,
                is_loading_esign: false,
                is_generate_new_esign: false,
                is_use_esign: false,
                nric_attachments: [],
                prev_b46_front_nric: null,
                prev_b46_back_nric: null,
                prev_b46_consent_form: null,
            }
        },
        watch:{
            'form.government_servant'(newVal){
                this.form.angkasa = false
                if(newVal === true){
                    this.form.angkasa = true
                }
            },
            // 'form.angkasa'(newVal){
            //     if(newVal === false && this.form.government_servant){
            //         this.form.government_servant = false
            //     }
            // },
            'current_commitment'(newVal){
                if(newVal){
                    this.dropzoneGetFrontNRIC();
                    this.dropzoneGetBackNRIC();
                }
            },
            'current_customer'(newVal){
                if(newVal){
									this.initForm();
                }
            },
            //  'form.platform'(newVal) {
            //   if (newVal === 'CTOS') {
            //     this.form.ccris = false
            //   }
            //   if (newVal === 'CBM') {
            //     this.form.ccris = true
            //   }
              // // If app is SAS and platform is CBM, ensure CBM-specific options are checked
              // if (_gAuth.isAppSas() && newVal === 'CBM') {
              //     this.form.trade_reference = true
              //     this.form.ccris = true
              // }
           // }
        },
        computed:{
            ...mapState(useAuthStore,['auth_user']),
            ...mapState(useCustomerStore, ['current_customer', 'current_commitment']),
            ...mapState(useFintscoreStore, ['latest_consent', 'is_new_esign', 'discount_fintscore_price', 'ctos_addons', 'discount', 'fintscore_price', 'cbm_fintscore_price', 'discount_cbm_fintscore_price']),
            ctosPurchaseNoDiscountPrice(){
                let price = this.form.platform == 'CBM' ? this.cbm_fintscore_price : this.fintscore_price

                if(this.form.angkasa){
                    price += this.ctos_addons.ctos_angkasa
                }
                if(this.form.liabilities){
                    price += this.ctos_addons.ctos_lg_guarantor_price
                }
                if(this.form.ccris){
                    price += this.ctos_addons.ctos_ccris_price
                }
                if(this.form.trade_reference){
                    price += this.ctos_addons.trade_reference
                }
                return price
            },
            ctosPurchasePrice(){
                let price = this.form.platform == 'CBM' ? this.discount_cbm_fintscore_price : this.discount_fintscore_price

                if(this.form.angkasa){
                    price += this.ctos_addons.disounct_ctos_angkasa
                }
                if(this.form.liabilities){
                    price += this.ctos_addons.disounct_ctos_lg_guarantor_price
                }
                if(this.form.ccris){
                    price += this.ctos_addons.disounct_ctos_ccris_price
                }
                if(this.form.trade_reference){
                    price += this.ctos_addons.disounct_trade_reference
                }
                return price
            },
            disableGenerate() {
                 if (this.latest_consent !== null) {
                    const expirationDate = new Date(this.latest_consent.cce_expired_date)
                    const currentDate = new Date()
                    return expirationDate > currentDate
                }
                return false
            },
						consentFormUrl(){
							// return 'https://sas.imortgage2u.com/portal/download_files/CTOS-Consent-Form-Techapp-V2.pdf'
              return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/Standard+INDIVIDUAL+Consent+Form+(CBM+%26+CTOS+FAIR+Copy+07.05.2024).pdf'
            },
						isGovernment(){
							return (!_gHlp.isEmpty(this.current_customer) && !_gHlp.isEmpty(this.current_customer.incomes) && (this.current_customer.incomes.main.income_type_id == 3 || this.current_customer.incomes.main.income_type_id == 5));
						},
						isCreditEnough(){
							return _gAuth.activeUser('subscription.scrb_credit_points',0) >= this.ctosPurchasePrice;
						},
            effectivePlatform() {
              // If platform is CBM and trade reference is checked, use CBM_TR
              // Otherwise use the original platform
              if (this.form.platform === 'CBM' && this.form.trade_reference) {
                return 'CBM_TR';
              }
              return this.form.platform;
            }
        },
				mounted(){
						this.initForm();
        },
        methods: {
            ...mapActions(useAuthStore, ['fetchUserInfo']),
            ...mapActions(useCustomerStore, ['getCommitment', 'generateDSR']),
            ...mapActions(useFintscoreStore, ['getNewConsent', 'getEsignConsent']),
						selectPlatformType(platform){
							this.form.platform = platform;
							// if(this.form.platform == 'CBM'){
							// 	this.form.trade_reference = true
							// }
						},
            showReloadModal(){
                this.$refs.reloadFintscoreCreditModalRef.toggleModal()
            },
            dropzoneErrorConsentForm(file, error, xhr){
                this.form.consent_form = null
            },
            dropzoneAddedConsentForm(file){
                this.form.consent_form = file
            },
            dropzoneRemovedConsentForm(file, error, xhr){
                this.form.consent_form = null
            },
            dropzoneErrorFrontNRIC(){
                this.form.front_nric = null
            },
            dropzoneAddedFrontNRIC(file){
                this.form.front_nric = file
            },
            dropzoneRemovedFrontNRIC(file, error, xhr){
                this.form.front_nric = null
            },
            dropzoneErrorBackNRIC(file, error, xhr){
                this.form.back_nric = null
            },
            dropzoneAddedBackNRIC(file){
                this.form.back_nric = file
            },
            dropzoneRemovedBackNRIC(file, error, xhr){
                this.form.back_nric = null
            },
            async dropzoneGetFrontNRIC() {
							this.prev_b46_front_nric = null;
							if(!_gHlp.isEmpty(this.current_commitment) && !_gHlp.isEmpty(this.current_commitment.credit_report_ic_front_base64)){
								// this.prev_b46_front_nric = await _gFile.getContentUrl(this.current_commitment.credit_report_ic_front_unsigned_url)
								this.prev_b46_front_nric = this.current_commitment.credit_report_ic_front_base64
							}	
            },
            async dropzoneGetBackNRIC() {
							this.prev_b46_back_nric = null;
							if(!_gHlp.isEmpty(this.current_commitment) && !_gHlp.isEmpty(this.current_commitment.credit_report_ic_back_base64)){
								// this.prev_b46_back_nric = await  _gFile.getContentUrl(this.current_commitment.credit_report_ic_back_unsigned_url)
								this.prev_b46_back_nric = this.current_commitment.credit_report_ic_back_base64
							}	
            },
						reupload(file_type){
							if(file_type == 'ic_front'){
								console.log(this.prev_b46_front_nric);
								this.prev_b46_front_nric = null;
							}
							if(file_type == 'ic_back'){
								this.prev_b46_back_nric = null;
							}
							if(file_type == 'consent_form'){
								this.prev_b46_consent_form= null;
							}
						},
            async viewDetails() {
                this.drawerBuyFintscoreReport = !this.drawerBuyFintscoreReport;
                if(this.drawerBuyFintscoreReport && this.is_first_load){
                    this.is_first_load = false
                    await this.getEsignConsentHandler()
                }
            },
						initForm(){
							if(this.isGovernment){
								this.form.government_servant = true;
								this.form.angkasa = true;
							}
                            if(_gAuth.isAppSas() && !_gHlp.checkAccess(['allow_pull_ctos'])){
                                this.selectPlatformType('CBM');
                            }
                            // Ensure CBM-related checkboxes are true when SAS and CBM
                            // if(_gAuth.isAppSas() && this.form.platform === 'CBM'){
                            //     this.form.trade_reference = true;
                            //     this.form.ccris = true;
                            // }
							this.initial_form_values = { ...this.form };

						},
            resetForm(){
                if(!_gHlp.isEmpty(this.$refs.consentFormDropzone)) this.$refs.consentFormDropzone.removeAllFiles();
                if(!_gHlp.isEmpty(this.$refs.frontNRICDropzone)) this.$refs.frontNRICDropzone.removeAllFiles();
                if(!_gHlp.isEmpty(this.$refs.backNRICDropzone)) this.$refs.backNRICDropzone.removeAllFiles();
                this.form = { ...this.initial_form_values };
            },
            async convertFileToBase64(file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        resolve(reader.result);
                    };
                    reader.onerror = reject;
                });
            },
						async purchaseReport(is_direct_payment = 0){
                if((!this.form.consent_form && !this.is_use_esign && _gHlp.isEmpty(this.prev_b46_consent_form)) || (this.is_use_esign && _gHlp.isEmpty(this.latest_consent))){
                    this.errorFunction(null, 'Esign / Manual Consent Form is required.')
                    return
                }

                if(!this.form.front_nric && _gHlp.isEmpty(this.prev_b46_front_nric)){
                    this.errorFunction(null, 'Front NRIC is required.')
                    return
                }
                if(!this.form.back_nric && _gHlp.isEmpty(this.prev_b46_back_nric)){
                    this.errorFunction(null, 'Back NRIC is required.')
                    return
                }
								
                let max_size = 20000000 // 20mb
                let max_size_2mb = 2000000
                // check file sizes
                if(this.form.consent_form && this.form.consent_form.size > max_size_2mb){
                    this.errorFunction(null, 'Consent Form file size is too big. Max is 2MB.')
                    return
                }
                if(this.form.front_nric && this.form.front_nric.size > max_size){
                    this.errorFunction(null, 'Front NRIC file size is too big. Max is 20MB.')
                    return
                }
                if(this.form.back_nric && this.form.back_nric.size > max_size){
                    this.errorFunction(null, 'Back NRIC file size is too big. Max is 20MB.')
                    return
                }

                // check if should make direct payment or deduct from report
                // if(this.form.angkasa || this.form.ccris || this.form.liabilities){
                //     is_direct_payment = 1
                // }

                // check if not enough balance and not direct payment
                if(!this.isCreditEnough && !is_direct_payment){
                    this.errorFunction(null, 'Please reload to purchase report.')
                    return
                }

                let message = "Are you sure all the details are correct?";
                if (confirm(message) == true) {
                    // MANUAL OVERRIDE ESIGN
                    //if has manual form, use manual
										let base64_consent_form = null
										let base64_consent_im2u_copy = null
                    if(this.form.consent_form){
											base64_consent_form = await this.convertFileToBase64(this.form.consent_form);
                    }
                    // if use esign and no manual, use esign
                    if (this.is_use_esign && !this.form.consent_form && !_gHlp.isEmpty(this.latest_consent) && !_gHlp.isEmpty(this.latest_consent.esign_attachment)) {
											const mainConsent = this.latest_consent.esign_attachment.find((item) => item.attachment_kind == "CONSENT_FORM")
											if(!_gHlp.isEmpty(mainConsent)){
												base64_consent_form = mainConsent.attachment_base64
											}
											const copyConsent = this.latest_consent.esign_attachment.find((item) => item.attachment_kind == "CONSENT_IM2U_COPY")
											if(!_gHlp.isEmpty(copyConsent)){
												base64_consent_im2u_copy = copyConsent.attachment_base64
											}
                    }

                    let base64_front_nric = null
                    if(this.form.front_nric){
                        base64_front_nric = await this.convertFileToBase64(this.form.front_nric);
                    }else if(!_gHlp.isEmpty(this.prev_b46_front_nric)){
											base64_front_nric = this.prev_b46_front_nric;
										}

                    let base64_back_nric = null
                    if(this.form.back_nric){
                        base64_back_nric = await this.convertFileToBase64(this.form.back_nric);
                    } 
										if(!_gHlp.isEmpty(this.prev_b46_back_nric)){
											base64_back_nric = this.prev_b46_back_nric;
										}

                    let form = {
                        "test_mode":CTOS_TEST_MODE === 'true' ? true : false, // set to false will make real purchase !,
                        "credit_report_scrb_id": this.auth_user.subscription.scrb_id,
                        "credit_report_type":"individual",
                        "credit_report_platform": this.form.platform,
                        "credit_report_cust_name": this.current_customer.name,
                        "credit_report_cust_dob": this.current_customer.dob,
                        "credit_report_cust_ic": this.current_customer.nric,
                        "credit_report_angkasa": this.form.angkasa ? 1 : 0,
                        "credit_report_trade_ref": this.form.trade_reference ? 1 : 0,
                        "credit_report_ccris": this.form.ccris ? 1 : 0,
                        "credit_report_lg_guarantor": this.form.liabilities ? 1 : 0,
                        "credit_report_ssm": 0, // 1 if company purchase
                        "credit_report_custom_identifier": 'im2uv2-' + this.current_customer.nric + '-by_user-' + this.auth_user.id,
                        "credit_report_conset_content": base64_consent_form,
                        "credit_report_cust_id": this.current_customer.customer_id,
                        "credit_report_ic_front_content": base64_front_nric,
                        "credit_report_ic_back_content": base64_back_nric,
                        "credit_report_generate_payment": is_direct_payment,
                        "credit_report_cust_is_new": 0,
                        "credit_report_redirect_url": window.location.href
                    }

										if(!_gHlp.isEmpty(base64_consent_im2u_copy)){
											form['credit_report_conset_im2u_content'] = base64_consent_im2u_copy
                    }

                    if(is_direct_payment){
                        this.is_loading_purchase = true
                        axios.post(services.commitment + 'credit-report', form, {headers: getHeader()})
                            .then(res => {
                                this.is_loading_purchase = false
                                window.location.href  = res.data.pay_url
                            })
                            .catch(e => {
                                this.is_loading_purchase = false
                                this.errorFunction(e)
                            })
                    }else{
                        this.is_loading_purchase = true
                        axios.post(services.commitment + 'credit-report', form, {headers: getHeader()})
                            .then(res => {
                                this.is_use_esign = false
                                this.$emit('new-purchase-report')
                                this.is_loading_purchase = false
                                this.resetForm()
                                this.drawerBuyFintscoreReport = false
                                this.notifySuccess('<b>Report Purchase: </b> - Successfull.')
                                setTimeout(() => {
                                    window.location.reload();
                                }, 100);
                                this.getCommitment()
                                this.generateDSR()
                                this.fetchUserInfo() // to update report balance
                                if(this.$route.query.active && this.$route.query.active !== 'commitment'){
                                    const query = { ...this.$route.query, active: 'commitment' };
                                    this.$router.push({path: this.$route.path, query});
                                }
                            })
                            .catch(e => {
                                this.is_use_esign = false
                                this.is_loading_purchase = false
                                this.errorFunction(e)
                            })
                    }
                }
            },
            async getNewConsentHandler(customer){
                let message = "This will generate a new Esign and send an OTP message to the customer. Are you sure?";
                if (confirm(message) == true) {                
                    this.is_generate_new_esign = true
                    try{
                        await this.getNewConsent(customer)
                    }catch(e){
                        this.errorFunction(e)
                    }
                    this.is_generate_new_esign = false
                }
            },
            async getEsignConsentHandler(){
                this.is_loading_esign = true
                await this.getEsignConsent(this.current_customer.customer_id)
                this.is_loading_esign = false
            },

            async previewConsentForm() {
                try {
                    const corporateId = _gAuth.activeCorporateId();
                    const response = await axios.get(services.access_control + 'corporate/' + corporateId, { headers: getHeader() });
                    this.modals.company_entity_name = response.data.data.company_entity_name; 
                    this.modals.show_preview = true
                } catch (e) {
                    this.errorFunction(e);
                } 
            },
        }
    }
</script>